import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const KST = 'Asia/Seoul' as const;

const PATTERN = {
  short: 'MM/DD',
  full: 'YYYY/MM/DD',
} as const;

const SEPARATOR = {
  short: '-',
  full: '~',
} as const;

export const formatDateRange = (
  startIso: string,
  endIso: string,
  variant: 'short' | 'full' = 'short',
): string => {
  const start = dayjs(startIso).tz(KST).format(PATTERN[variant]);
  const end = dayjs(endIso).tz(KST).format(PATTERN[variant]);

  return `${start} ${SEPARATOR[variant]} ${end}`;
};
